import React, { Component } from 'react'
import TabsProvider from '../tabs-provider'

class ShowSessionSale extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { params: { sessionSaleId }, location, children } = this.props
    const { loading } = this.state

    if (loading) {
      return null
    }

    const tabs = [
      {
        label: 'Summary',
        path: `/events/session-sales/${sessionSaleId}/summary`
      },
      {
        label: 'Edit Session Sale',
        path: `/events/session-sales/${sessionSaleId}/edit`
      },
      {
        label: 'Reservations',
        path: `/events/session-sales/${sessionSaleId}/reservations`
      },
      {
        label: 'Waitlist',
        path: `/events/session-sales/${sessionSaleId}/waitlist`
      },
      {
        label: 'Intake Questions',
        path: `/events/session-sales/${sessionSaleId}/intake-questions`
      },
      {
        label: 'Registration Blocks',
        path: `/events/session-sales/${sessionSaleId}/registration-blocks`
      }
    ]
    return (
      <div>
        <TabsProvider
          pathname={location.pathname}
// @ts-ignore
          location={location}
          tabs={tabs}
        />
        {children}
      </div>
    )
  }
}

export default ShowSessionSale
